import { IWorkspaceDB } from '@monofe/apiservice';
import { ILanguageDto } from '@monofe/apiservice/model';
import { IMediumDto } from '@monofe/apiservice/model';
import { ISiteObjectDto } from '@monofe/apiservice/model';
import { injectAPISession } from '@monofe/apiservice';
import { DataCheckResult } from '../interface';
import { IRouteSiteObjectArguments } from './interface';
import { injectLog } from '../../interface/util';

function mediaRequired(
    siteObject: ISiteObjectDto,
    language: ILanguageDto,
    db: IWorkspaceDB,
): Promise<Array<IMediumDto>> {
    const log = injectLog();

    return new Promise(async function (resolve, reject) {
        try {
            let media: IMediumDto[] = [];

            const translation = await siteObject.translation(db, language);

            if (translation.mediumId) {
                media.push(await translation.medium(db));
            }

            resolve(media);
        } catch (error) {
            log.error('Failed to map media ' + error);
            reject(error);
        }
    });
}

function NeedsInternet(route: IRouteSiteObjectArguments): Promise<boolean> {
    return new Promise(async function (resolve, reject) {
        try {
            const workspace = await injectAPISession().open(route.sessionName);

            await workspace.db.open();

            const language = await workspace.db.get('ILanguageDto', route.languageId);

            const siteObject = await workspace.db.get('ISiteObjectDto', route.siteObjectId);

            const requiredMedia = await mediaRequired(siteObject, language, workspace.db);

            const allCached = await workspace.media.isAllMediaCached(
                requiredMedia.map(medium => medium.id),
            );

            const needsInternet = !allCached;

            workspace.db.close();

            resolve(needsInternet);
        } catch (error) {
            reject(error);
        }
    });
}
function CanLoad(route: IRouteSiteObjectArguments): Promise<DataCheckResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const needsInternet = await NeedsInternet(route);

            resolve(
                needsInternet
                    ? DataCheckResult.DataNetworkConnectionNeeded
                    : DataCheckResult.DataAvailableOffline,
            );
        } catch (error) {
            reject(error);
        }
    });
}

export default CanLoad;
